import { getEndpoint } from "@api-routes/endpoint";

const USERS_MS_NAME = "users";
export const CHANGE_EMAIL_REQUEST_ROUTE = `${getEndpoint(USERS_MS_NAME)}change_email/request`;

export const SEND_VERIFICATION_EMAIL_ROUTE = `${getEndpoint(USERS_MS_NAME)}send_verification_email`;

export const RESET_PASSWORD_ROUTE = `${getEndpoint(USERS_MS_NAME)}password/reset`;

export const RECOVER_EMAIL_GENERATE_OTP_ROUTE = `${getEndpoint(USERS_MS_NAME)}recover_email/otp/generate`;

export const RECOVER_EMAIL_VALIDATE_OTP_ROUTE = `${getEndpoint(USERS_MS_NAME)}recover_email/otp/validate`;
